import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_settings/settings/")({
  staticData: { title: "Settings", breadcrumb: "Settings" },
  component: Settings,
});

function Settings() {
  return (
    <div>
      <h1>Settings</h1>
      <section>
        <h2>Profile</h2>
        <p>Name: John Doe</p>
        <p>Email: john@signal7.io</p>
      </section>
      <section>
        <h2>Notifications</h2>
        <p>Email alerts: Enabled</p>
        <p>SMS alerts: Disabled</p>
      </section>
      <section>
        <h2>Integrations</h2>
        <p>CRM: Connected</p>
        <p>Slack: Not connected</p>
      </section>
    </div>
  );
}
